export default __webpack_public_path__ + "static/media/Flag_of_Brunei.64d00155.svg";